import React, { useState } from 'react';
import { AiOutlineInfoCircle } from 'react-icons/ai';
import Input from '../../atoms/Input';
import CloseCircle from '../../atoms/Icons/CloseCircle';
import SearchIcon from '../../atoms/Icons/SearchIcon';
import { IServicesPackages } from '../ServicesListSection/interface';

interface ISearchNewCarProps {
  className?: string;
  freeTextSearch?: string;
  placeholderText?: string;
  iconColor?: string;
  onValueChange?: (value: string) => void;
  handleClickSearch?: (value: string) => void;
  recs?: IServicesPackages[];
  filterRecs?: (value: string) => void;
}

export default function SearchNewCar({
  className = '',
  freeTextSearch = '',
  placeholderText = 'Cari mobil',
  iconColor = '#231F20',
  onValueChange = () => {},
  recs,
  handleClickSearch,
  filterRecs,
}: ISearchNewCarProps) {
  const [inputValues, setInputValues] = useState(freeTextSearch);
  const [isFocused, setIsFocused] = useState(false);

  const handleChange = (e) => {
    onValueChange(e.target.value);
    setInputValues(e.target.value);
  };

  const handleOnClickRemoveSearch = () => {
    onValueChange('');
    setInputValues('');
    handleClickSearch('');
  };

  const handleFocus = (): void => {
    setIsFocused(true);
    if (inputValues.length >= 2) {
      filterRecs(inputValues);
    }
  };

  const handleBlur = (e: React.FocusEvent): void => {
    setIsFocused(false);
  };

  const handleSubmit = (e) => {
    e?.preventDefault();
    handleClickSearch(inputValues);
  };

  return (
    <form
      onSubmit={handleSubmit}
      className={`relative w-full flex items-center gap-2 justify-start xl:border-b xl:border-reliableBlack20 ${className}`}
    >
      <SearchIcon size={20} fill={iconColor} />
      <Input
        id="dd-search-navbar"
        type="text"
        placeholder={placeholderText}
        icon={inputValues && <CloseCircle size={16} />}
        iconPosition="right"
        iconClassName={'border-none'}
        labelClassName="text-reliableBlack70 font-semibold"
        containerClassName={'flex-1 md:ml-4 xl:ml-0 xl:w-full'}
        inputClassName={`max-h-none !px-0 py-3 text-xs border-none xl:max-h-none xl:px-0 xl:py-[18px] xl:text-sm placeholder:italic placeholder:!text-reliableBlack50`}
        inputBackground={'bg-white'}
        value={inputValues}
        onChange={handleChange}
        onBlur={handleBlur}
        onFocus={handleFocus}
        handleOnClickIcon={inputValues ? handleOnClickRemoveSearch : null}
      />
      {isFocused && recs?.length > 0 && (
        <div
          onMouseDown={(e) => e.preventDefault()}
          className="z-50 absolute w-full top-full left-0 bg-white max-h-[200px] overflow-y-auto flex flex-col gap-2 px-4"
        >
          {recs?.map((item) => (
            <div
              key={item?.code}
              className={`${item?.carModelService && 'hover:cursor-pointer hover:bg-black/10'} flex items-center justify-start w-full py-2`}
              onClick={() => handleClickSearch(item?.carModelService)}
            >
              {item?.carModelService && (
                <div className="flex gap-2 items-center justify-start">
                  <SearchIcon size={20} fill={iconColor} />
                  <p>{item.name}</p>
                </div>
              )}
              {!item?.carModelService && (
                <div className="flex gap-2 items-center justify-start">
                  <AiOutlineInfoCircle />
                  <p>Hasil Tidak Ditemukan</p>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </form>
  );
}
